import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class CryptoJsService {

  protected keys = 'M3g@S4p0'.padEnd(16, '#');

  constructor() { }

  // // The set method is use for encrypt the value.
  // encrypt(value){
  //   const key = CryptoJS.enc.Utf8.parse(this.keys);
  //   const iv = CryptoJS.enc.Utf8.parse(this.keys);
  //   const encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(value.toString()), key,
  //     {
  //       keySize: 128 / 8,
  //       iv,
  //       mode: CryptoJS.mode.CBC,
  //       padding: CryptoJS.pad.Pkcs7
  //     });

  //   return encrypted.toString();
  // }

  // The get method is use for decrypt the value.
  // decrypt(value){
  //   const key = CryptoJS.enc.Utf8.parse(this.keys);
  //   const iv = CryptoJS.enc.Utf8.parse(this.keys);
  //   const decrypted = CryptoJS.AES.decrypt(value, key, {
  //     keySize: 128 / 8,
  //     iv,
  //     mode: CryptoJS.mode.CBC,
  //     padding: CryptoJS.pad.Pkcs7
  //   });

  //   return decrypted.toString(CryptoJS.enc.Utf8);
  // }


  // encryptUsingAES256(value) {
  //   const _key = CryptoJS.enc.Utf8.parse(this.keys);
  //   const _iv = CryptoJS.enc.Utf8.parse(this.keys);
  //   const encrypted = CryptoJS.AES.encrypt(
  //     JSON.stringify(value), _key, {
  //       keySize: 16,
  //       iv: _iv,
  //       mode: CryptoJS.mode.ECB,
  //       padding: CryptoJS.pad.Pkcs7
  //     });

  //   return encrypted.toString();
  // }

  // decryptUsingAES256(value) {
  //   const _key = CryptoJS.enc.Utf8.parse(this.keys);
  //   const _iv = CryptoJS.enc.Utf8.parse(this.keys);

  //   const decrypted = CryptoJS.AES.decrypt(
  //     value, _key, {
  //       keySize: 16,
  //       iv: _iv,
  //       mode: CryptoJS.mode.ECB,
  //       padding: CryptoJS.pad.Pkcs7
  //     }).toString(CryptoJS.enc.Utf8);

  //   return decrypted;
  // }

  setItem(key: string, value: any): void {
    const encryptedValue = CryptoJS.AES.encrypt(JSON.stringify(value), this.keys).toString();
    localStorage.setItem(key, encryptedValue);
  }

  getItem(key: string): any {
    const encryptedValue = localStorage.getItem(key);
    if (encryptedValue) {
      const decryptedValue = CryptoJS.AES.decrypt(encryptedValue, this.keys).toString(CryptoJS.enc.Utf8);
      return JSON.parse(decryptedValue);
    }
    return null;
  }

  
  decryptItem(encryptedValue: string): any {
    try {
      if (!encryptedValue) {
        throw new Error('No existe un valor para desencriptar.');
        
      }

      if (!/^[A-Za-z0-9+/=]+$/.test(encryptedValue)) {
 
        throw new Error('Formato Invalido Base64.');
      }
  
      const decryptedBytes = CryptoJS.AES.decrypt(encryptedValue, this.keys);
      // //console.log('Decrypted Bytes:', decryptedBytes);
  
      const decryptedText = decryptedBytes.toString(CryptoJS.enc.Utf8);
      // //console.log('Decrypted Text:', decryptedText);
  
      if (!decryptedText) {
        
        throw new Error('Decryption failed: Texto invalido para la desencriptación.');
      }
  
      return JSON.parse(decryptedText); // Asume que el resultado es un JSON
    } catch (error) {
      // console.error('Error during decryption:', error.message);
      return null;
    }
  }
  

  encryptItem(value: any): string {
    const encryptedValue = CryptoJS.AES.encrypt(JSON.stringify(value), this.keys).toString();
    return encryptedValue;
  }

  removeItem(key: string): void {
    localStorage.removeItem(key);
  }

  clear(): void {
    localStorage.clear();
  }
}
